__turbopack_context__.v({
  "menuItem": "sidebar-module-scss-module__QT2nhG__menuItem",
  "menuItemActive": "sidebar-module-scss-module__QT2nhG__menuItemActive",
  "shine": "sidebar-module-scss-module__QT2nhG__shine",
  "sidebarLogo": "sidebar-module-scss-module__QT2nhG__sidebarLogo",
  "sidebarSection": "sidebar-module-scss-module__QT2nhG__sidebarSection",
});
